<template>
  <div id="app">
     <router-view @toPageFunc="toPageFunc"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getUrlParam, setCookie, getCookie } from 'src/assets/public.js'

export default {
  name: 'App',
  computed: mapState({
    clientWidth: state => state.clientWidth
  }),
  data () {
    return {}
  },
  methods: {
    getSessionStrageInfoFunc () {
      const projectId = sessionStorage.getItem('session_projectId')
      const projectName = sessionStorage.getItem('session_projectName')
      const userInfo = sessionStorage.getItem('session_userInfo') || localStorage.getItem('session_userInfo')
      console.log('=================projectId:' + projectId)
      this.$store.commit('setProjectId', projectId || 1)
      this.$store.commit('setProjectName', projectName || '')
      this.$store.commit('setUserInfo', JSON.parse(userInfo))
    },
    toPageFunc (url) {
      this.$router.push(url)
    },
    setClientSizeFunc () {
      this.$store.commit('setClientWidth', document.body.clientWidth)
      this.$store.commit('setClientHeight', document.body.clientHeight)
    }
  },
  mounted () {
    // if (getUrlParam('KGSYSID')) { // 如果存在sessionid 那么设置cookie和获取用户信息
    //   setCookie('userKey', getUrlParam('KGSYSID'))
    // }
    // // console.log('=================')
    // // console.log(getUrlParam('KGSYSID'))
    // // console.log(getCookie('userKey'))
    // // console.log(sessionStorage.getItem('session_userInfo'))
    // if (getCookie('userKey') && sessionStorage.getItem('session_userInfo') === 'null') { // 如果存在sessionid 那么设置cookie和获取用户信息
    //   console.log('请求用户信息')
    //   let successCallback = (resp) => {
    //     console.log('请求用户信息')
    //     let dataObj = resp.data
    //     let userInfo = dataObj.data.user
    //     this.$store.commit('setUserInfo', userInfo)
    //   }
    //   this.$Request.getUserInfo({
    //     data: {},
    //     success: successCallback,
    //     async: false
    //   })
    // }
    // this.getSessionStrageInfoFunc()
    // this.setClientSizeFunc()
    // window.addEventListener('resize', () => {
    //   this.setClientSizeFunc()
    // })

    // console.log('=================')
    // console.log(getUrlParam('KGSYSID'))
    // console.log(getCookie('userKey'))
    // console.log(sessionStorage.getItem('session_userInfo'))
    console.log('请求用户信息')
    let successCallback = (resp) => {
      console.log('请求用户信息')
      let dataObj = resp.data
      let userInfo = dataObj.data.user
      this.$store.commit('setUserInfo', userInfo)
    }
    this.$Request.getUserInfo({
      data: {},
      success: successCallback,
      async: false
    })
    this.getSessionStrageInfoFunc()
    this.setClientSizeFunc()
    window.addEventListener('resize', () => {
      this.setClientSizeFunc()
    })
  }
}
</script>

<style lang="less">
  #app{
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/project_web/App.vue